module.exports = __webpack_public_path__ + "static/img/testskinplan.85ebea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testskinplan.png?v=1
// module id = J2yT
// module chunks = 1